import React from 'react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onViewOrder: () => void;
}

const OrderSuccessModal: React.FC<Props> = ({ isOpen, onClose, onViewOrder }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-primary-dark/40 dark:bg-black/80 backdrop-blur-md animate-fade-in"
        onClick={onClose}
      ></div>

      {/* Modal Container */}
      <div className="relative bg-white/95 dark:bg-surface-dark/95 backdrop-blur-2xl w-full max-w-sm rounded-[3rem] shadow-[0_32px_64px_-16px_rgba(0,0,0,0.2)] p-10 text-center animate-scale-up border border-white/20">

        {/* Success Icon Centerpiece */}
        <div className="relative mb-10">
          <div className="w-24 h-24 bg-primary rounded-[2rem] flex items-center justify-center mx-auto shadow-2xl shadow-primary/30 rotate-3 group overflow-hidden">
            <div className="absolute inset-0 opacity-20 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
            <span className="material-icons-round text-5xl text-white animate-bounce">check</span>
          </div>
          {/* Decorative particles (Visual only) */}
          <div className="absolute top-0 right-1/4 w-2 h-2 rounded-full bg-primary/40 animate-ping"></div>
          <div className="absolute bottom-4 left-1/4 w-3 h-3 rounded-full bg-primary/20 animate-pulse"></div>
        </div>

        <div className="space-y-4 mb-10">
          <h2 className="text-3xl font-black text-primary-dark dark:text-white tracking-tighter uppercase leading-none">Order Secured!</h2>
          <div className="flex flex-col gap-1 items-center">
            <p className="text-[10px] font-black text-primary uppercase tracking-[0.3em]">Simulation Protocol Clear</p>
            <p className="text-sm font-medium text-gray-400 dark:text-gray-500 max-w-[240px] mx-auto leading-relaxed">
              Your supplies are being prepared for immediate dispatch. Tracking manifest sent to dashboard.
            </p>
          </div>
        </div>

        <div className="space-y-4">
          <button
            onClick={onViewOrder}
            className="group w-full bg-primary hover:bg-primary-dark text-white font-black py-5 rounded-2xl shadow-2xl shadow-primary/30 transition-all flex items-center justify-center gap-3 active:scale-95 uppercase text-[11px] tracking-[0.15em]"
          >
            View Manifest
            <span className="material-icons-round text-lg group-hover:-translate-y-1 group-hover:translate-x-1 transition-transform">receipt_long</span>
          </button>
          <button
            onClick={onClose}
            className="w-full bg-transparent hover:bg-primary/5 text-gray-400 hover:text-primary font-black py-4 rounded-2xl transition-all border border-transparent hover:border-primary/10 uppercase text-[10px] tracking-widest"
          >
            Return to Hub
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccessModal;